/**
 * Shipping and packaging related reducer functions
 */

/**
 * Set express shipping
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} shippingData - Shipping data
 */
export const setExpressShipping = (global, dispatch, shippingData) => {
  return {
    cartUpdating: true,
    showPayment: false,
    shippingID: shippingData && shippingData.id ? shippingData.id : "",
  }
}

/**
 * Set standard shipping
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} shippingData - Shipping data
 */
export const setShipping = (global, dispatch, shippingData) => {
  return {
    showPayment: true,
    shippingID: shippingData && shippingData.id ? shippingData.id : "",
  }
}

/**
 * Set packaging option
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} packagingData - Packaging data
 */
export const setPackagingOption = (global, dispatch, packagingData) => {
  return {
    packagingID: packagingData && packagingData.id ? packagingData.id : "",
  }
}

/**
 * Set address information
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} data - Address data
 */
export const setAddress = (global, dispatch, data) => {
  const addressData = { showShipping: true, cartUpdating: true }
  addressData[data.addressType] = {
    ...data.address,
    complete: true,
    addressOpen: true,
  }

  return {
    ...addressData,
    ...data.otherData,
  }
}

/**
 * Set different billing address flag
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {boolean} differentBilling - Whether billing address is different
 */
export const differentBilling = (global, dispatch, differentBilling) => {
  return { differentBillingAddress: differentBilling }
}
